/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @angular-eslint/prefer-on-push-component-change-detection */

import { Component, OnInit, inject } from '@angular/core';
import { Performance } from '@angular/fire/performance';
import { finalize } from 'rxjs/operators';

import { UsersService } from './services/users.service';

import { ConnectedUserModel } from './interfaces/users-models';

@Component({
  selector: 'app-root',
  standalone: false, // eslint-disable-line @angular-eslint/prefer-standalone
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private perf: Performance;
  isLoading = true;
  connectedUser: ConnectedUserModel | null;
  usersService: UsersService;

  constructor() {
    this.usersService = inject(UsersService);
    this.connectedUser = this.usersService.getConnectedUserSync();
    this.perf = inject(Performance);
  }

  ngOnInit(): void {
    this.usersService
      .getConnectedUser()
      .pipe(
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe((user) => {
        this.connectedUser = user;
      });

    this.perf.dataCollectionEnabled = true;
    this.perf.instrumentationEnabled = true;
  }
}
